import React, { useRef, useState } from "react";
import { headChat } from "../../../assets/image";
import { BackButton, InputWithLabel } from "../../../components/micro";
import { useLocation, useNavigate } from "react-router-dom";
import { companyExist } from "../../../redux/companies/slice";
import { useDispatch, useSelector } from "react-redux";
import { InfoCircle } from "iconsax-react";
import { CheckCircleOutline } from "../../../assets/svg/AllSvg";
import { createServicesRequest } from "../../../redux/serviceRequest/slice";

const ChangeCompanyName = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const user_id = location?.state?.user_id;
  const company_id = location?.state?.company_id;
  const service = location?.state?.service;
  const buttonRef = useRef(null);
  const [companyName, setCompanyName] = useState("");
  const [companyExistError, setCompanyExistError] = useState(false);
  const [companyExistMessage, setCompanyExistMessage] = useState("");
  const [companyExistLoad, setCompanyExistLoad] = useState(false);

  // Selector
  const createServicesRequestData = useSelector(
    (store) => store?.serviceRequestData?.createServicesRequestStatus?.data
  );
  const createServicesRequestLoading = useSelector(
    (store) => store?.serviceRequestData?.loading
  );

  // Check Company Exist
  const handleCheckCompanyExist = () => {
    setCompanyExistLoad(true);
    dispatch(companyExist({ company_name: companyName, id: company_id })).then(
      (res) => {
        setCompanyExistLoad(false);
        if (res.type === "companyExist/fulfilled") {
          if (res?.payload?.data?.exist) {
            // Company Not Exist
            setCompanyExistError(true);
            setCompanyExistMessage(res.payload.message);
            setCompanyName("");
          } else {
            // Company Exist
            setCompanyExistError(false);
            setCompanyExistMessage(res.payload.message);
          }
        }
      }
    );
  };

  // Proceed with request
  const handleProceed = () => {
    const payload = {
      details: {
        company_name: companyName,
      },
      amount:
        service?.service_requests_count < service?.detail?.no_of_free_request
          ? 0
          : service?.detail?.price,
      user_id: user_id,
      company_id: company_id,
      service_id: service?.id,
    };
    dispatch(createServicesRequest(payload)).then((res) => {
      if (res.type !== "createServicesRequest/fulfilled") return;
      const { service_requests_count, detail } = service || {};
      const price = detail?.price || 0;
      if (
        service_requests_count < service?.detail?.no_of_free_request ||
        price <= 0
      ) {
        navigate("/approver");
      } else if (buttonRef.current) {
        buttonRef.current.click();
      } else {
        navigate("/approver");
      }
    });
  };

  return (
    <>
      <div className="space-y-5">
        <BackButton
          onClick={() => {
            navigate("/service");
          }}
        />
        <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
          <img src={headChat} alt="img" />
          <div className="space-y-2 font-ebGaramond">
            <p className="text-xl">We see that you will need a request on:</p>
            <p className="text-3xl">Change of Company Name</p>
          </div>
        </div>
        {/* Payment Button */}
        <a
          className="hidden"
          ref={buttonRef}
          href={createServicesRequestData?.data?.url}
        >
          Pay Now
        </a>
        <div className="space-y-3 border-b-2 border-secondary_grey pb-3">
          <p className="text-2xl font-ebGaramond">
            Let us guide u though the process:
          </p>
          <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
            <span>1.</span>
            <p>Check if the New Company Name is available</p>
          </div>
          <p className="text-sm">
            Before we change the name, you would need to make sure you have a
            unique company name.
          </p>
          <div>
            <div className="flex items-center gap-5">
              <div className="w-full">
                <InputWithLabel
                  className="border"
                  idFromName="company_name"
                  label="New Company Name"
                  type="text"
                  onChange={(e) => {
                    setCompanyName(e.target.value);
                  }}
                  value={companyName}
                />
              </div>
              <button
                type="button"
                disabled={!companyName?.length || companyExistLoad}
                className={`${
                  !companyName?.length || companyExistLoad
                    ? "btn-outline-disabled cursor-none"
                    : "btn-theme cursor-pointer"
                } whitespace-nowrap !py-2.5`}
                onClick={() => handleCheckCompanyExist()}
              >
                {companyExistLoad ? "Loading...." : "Check availability"}
              </button>
            </div>
            {companyExistMessage && (
              <div
                className={`flex items-center my-2 ${
                  companyExistError
                    ? "text-dark_extra_red bg-light_extra_red"
                    : "text-success bg-light_extra_green"
                } space-x-2 rounded px-5 py-3`}
              >
                {companyExistError ? (
                  <InfoCircle size="20" />
                ) : (
                  <CheckCircleOutline />
                )}
                <span className="font-normal sm:text-base text-sm">
                  {companyExistMessage}
                </span>
              </div>
            )}
            <p className="text-sm text-gray-400">
              *Company name availability is subject to final confirmation from
              regulating authority
            </p>
          </div>
          <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
            <span>2.</span>
            <p>We will prepare relevant resolution</p>
          </div>

          <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
            <span>3.</span>
            <p>Obtain signed resolution</p>
          </div>
          <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
            <span>4.</span>
            <p>
              We will lodge the changes to ACRA for the change of Company Name
            </p>
          </div>
          <p className="text-sm">
            Once the request is opened. You can easily manage it over at
            “On-Going” service page.
          </p>
        </div>
        <div className="flex items-center justify-between space-x-1  bg-light_primary_shades rounded-lg px-4 py-3">
          <p className="font-semibold">Total Payable :</p>
          <div>
            <p className="text-xs">
              {service?.service_requests_count}/
              {service?.detail?.no_of_free_request ?? 0} used
            </p>
            <p>
              {service?.service_requests_count >=
              service?.detail?.no_of_free_request
                ? `$${service?.detail?.price}`
                : "Free"}
            </p>
          </div>
        </div>
        <div className="box !rounded-xl flex items-center justify-between">
          <button
            className={`${
              createServicesRequestLoading || !companyName.length
                ? "btn-outline-disabled"
                : "btn-theme"
            } uppercase`}
            onClick={handleProceed}
          >
            {createServicesRequestLoading
              ? "Loading..."
              : "Proceed with request"}
          </button>
          <div>
            <p className="text-xs">Total:</p>
            <p>
              {service?.service_requests_count >=
              service?.detail?.no_of_free_request
                ? `$${service?.detail?.price}`
                : "Free"}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangeCompanyName;
